import styles from '../../styles/table.scss';
import Tooltip from '../ui/tooltip';
import { makeid } from '../../constants';

interface Props {
  data: any[][];
}

const Table = ({ data = [] }: Props) => (
  <table className={styles.table}>
    <thead>
      <tr>
        {data[0].map((column: any) => (
          <th colSpan={column.span} key={makeid()}>
            {column.value}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.slice(1).map((row: any) => {
        return (
          <tr key={makeid()}>
            {row.map((column, index) => {
              const ID = `${makeid()}-${index}`;
              return (
                <td key={makeid()}>
                  {column.value}
                  {column.info ? (
                    <Tooltip place={column.place} info={column.info} id={ID} />
                  ) : null}
                  {column.desc ? (
                    <p className={styles.desc}>{column.desc}</p>
                  ) : null}
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default Table;



// WEBPACK FOOTER //
// ./components/common/table.tsx